<!DOCTYPE html>
<ion-row class="title-head">
  <ion-col size="10" class="ion-no-padding">
    <p class="status-title">Just for you</p>
  </ion-col>
  <ion-col size="2" class="ion-no-padding">
    <img (click)="navigateToSyndicate()" class="support-img" src="assets/images/close-circle.png" alt="Close" />
  </ion-col>
</ion-row>
@if (condition) {
  <iframe class="iframe-Template" [src]="this.iframeLink"></iframe>
} @else {
  <iframe class="iframe-Template" src="https://www.example.com"></iframe>
}


